var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3090_38132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3090_38132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 27.5C13.7083 27.5 13.316 27.3368 12.9896 27.0104C12.6632 26.684 12.5 26.2917 12.5 25.8333V17.5C12.5 17.0417 12.6632 16.6493 12.9896 16.3229C13.316 15.9965 13.7083 15.8333 14.1667 15.8333H15.8333V14.1667C15.8333 13.7083 15.9965 13.316 16.3229 12.9896C16.6493 12.6632 17.0417 12.5 17.5 12.5H22.5C22.9583 12.5 23.3507 12.6632 23.6771 12.9896C24.0035 13.316 24.1667 13.7083 24.1667 14.1667V19.1667H25.8333C26.2917 19.1667 26.684 19.3299 27.0104 19.6563C27.3368 19.9826 27.5 20.375 27.5 20.8333V25.8333C27.5 26.2917 27.3368 26.684 27.0104 27.0104C26.684 27.3368 26.2917 27.5 25.8333 27.5H20.8333V24.1667H19.1667V27.5H14.1667ZM14.1667 25.8333H15.8333V24.1667H14.1667V25.8333ZM14.1667 22.5H15.8333V20.8333H14.1667V22.5ZM14.1667 19.1667H15.8333V17.5H14.1667V19.1667ZM17.5 22.5H19.1667V20.8333H17.5V22.5ZM17.5 19.1667H19.1667V17.5H17.5V19.1667ZM17.5 15.8333H19.1667V14.1667H17.5V15.8333ZM20.8333 22.5H22.5V20.8333H20.8333V22.5ZM20.8333 19.1667H22.5V17.5H20.8333V19.1667ZM20.8333 15.8333H22.5V14.1667H20.8333V15.8333ZM24.1667 25.8333H25.8333V24.1667H24.1667V25.8333ZM24.1667 22.5H25.8333V20.8333H24.1667V22.5Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicCompany);
export default __webpack_public_path__ + "static/media/publicCompany.edea2caa568f5c1a5372df0adc227a50.svg";
export { ForwardRef as ReactComponent };